import { GatewayService } from '../GatewayService';
import { PhicubeResponse } from '../interface/PhicubeResponse';

export class TokenProvider {
    salvaTokenApi(fcmToken: string): Promise<PhicubeResponse> {
        return new GatewayService().requestPut('/api/firebase/token', { token:  fcmToken })
    }
}